<p-card
  *ngIf="withCard"
  header="Платежные поручения"
  styleClass="compact-card {{ styleClass }}">
  <ng-template [ngTemplateOutlet]="table"></ng-template>
</p-card>

<ng-container *ngIf="!withCard">
  <ng-template [ngTemplateOutlet]="table"></ng-template>
</ng-container>

<ng-template #table>
  <crm-table
    *ngIf="orders?.length"
    name="paymentOrderTaskEdit"
    [columns]="columns"
    [values]="orders"
    styleClass="p-datatable-sm">
    <ng-template
      #rowTemplate
      let-order="item"
      let-index="rowIndex">
      <ng-container *ngIf="toOrder(order) as order">
        <tr>
          <td class="border-none">
            <div
              class="{{ currency && currency?.isoCharacter !== 'RUB' ? 'h-4rem flex align-items-start mt-4' : '' }}"
              *ngIf="order.id">
              №{{ order.id }}
            </div>
          </td>
          <td class="border-none max-w-8rem">
            <div
              class="{{
                currency && currency?.isoCharacter !== 'RUB' ? 'h-4rem flex flex-column align-items-start' : ''
              }}">
              <p-inputNumber
                [(ngModel)]="order.amount"
                (onInput)="changeAmountInOrder(order, $event.value)"
                [disabled]="disabled || (!withCard && !!order.id)"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                inputStyleClass="w-full"
                [class]="errors?.[index]?.amount ? 'ng-invalid ng-dirty' : ''"
                [styleClass]="errors?.[index]?.amount ? 'ng-invalid ng-dirty' : ''"></p-inputNumber>
              <div
                *ngIf="currency && currency?.isoCharacter !== 'RUB' && order.amount"
                class="text-medium text-sm uppercase mt-2 ml-2">
                {{ (order.amount || 0) * (rate || 1) | currency: 'RUB' : 'symbol' }}
              </div>
              <small
                *ngIf="errors?.[index]?.amount"
                class="p-error">
                {{ errors[index].amount | join }}
              </small>
            </div>
          </td>
          <td class="border-none max-w-12rem">
            <div
              class="{{
                currency && currency?.isoCharacter !== 'RUB' ? 'h-4rem flex flex-column align-items-start' : ''
              }}">
              <crm-datepicker
                [(value)]="order.date"
                [disabled]="disabled || (!withCard && !!order.id)"
                [minDate]="minDate"
                [inputStyleClass]="errors?.[index]?.date ? 'ng-invalid ng-dirty' : ''"
                styleClass="w-full"
                appendTo="body"></crm-datepicker>
              <small
                *ngIf="errors?.[index]?.date"
                class="p-error">
                {{ errors[index].date | join }}
              </small>
            </div>
          </td>
          <td class="border-none">
            <div
              class="{{
                currency && currency?.isoCharacter !== 'RUB' ? 'h-4rem flex flex-column align-items-start' : ''
              }}">
              <crm-template-subject-input
                *ngIf="templatedSubject"
                [(subject)]="order.subject"
                [isError]="$any(errors?.[index]?.subject) || order.subject?.length > 190"
                class="w-full"></crm-template-subject-input>
              <crm-input-text
                *ngIf="!templatedSubject"
                [(value)]="order.subject"
                [disabled]="disabled"
                [isError]="$any(errors?.[index]?.subject) || order.subject?.length > 190"
                class="w-full"></crm-input-text>
              <small
                *ngIf="errors?.[index]?.subject"
                class="p-error">
                {{ errors[index].subject | join }}
              </small>
              <small
                *ngIf="order.subject?.length > 190 && withCard"
                class="p-error">
                Назначение платежа не должно превышать 190 символов.
              </small>
            </div>
          </td>
          <td
            *ngIf="(!disabled && withCard) || (!withCard && !order.id)"
            class="border-none">
            <div
              class="{{
                currency && currency?.isoCharacter !== 'RUB' ? 'h-4rem flex flex-column align-items-start' : ''
              }}">
              <crm-button
                type="button"
                icon="pi pi-times"
                styleClass="p-button-rounded p-button-danger p-button-text"
                (onClick)="deleteOrder(order)"></crm-button>
            </div>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </crm-table>

  <div
    *ngIf="!disabled && withCard"
    class="p-3">
    <crm-button
      label="Добавить"
      icon="pi pi-plus"
      styleClass="p-button-text"
      (onClick)="addOrder()"></crm-button>
  </div>
</ng-template>
